import { IS_PROD, IS_DEV } from './env';
import { browserName } from 'detect-browser';
import { isBrowser } from 'browser-or-node';

export const COOKIE_CROSS_DOMAIN = IS_DEV ? undefined : 'linetv.tw';

export const COOKIE_APP_DOWNLOAD_MODAL = 'APP_DOWNLOAD_MODAL';

export const COOKIE_LAST_SIGNIN_PROVIDER = 'lastSigninProvider';

// for IndexAnnouncement (Jira CT-4464)
export const COOKIE_ANNOUNCEMENT_ID = 'announcementId';

export const COOKIE_PROFILE = 'profile';
export const COOKIE_CHOCOMEMBER_ID = IS_PROD ? 'chocomemberId' : 'chocomemberId_';
export const COOKIE_ACCESS_TOKEN = IS_PROD ? 'accessToken' : 'accessToken_';
export const COOKIE_REFRESH_TOKEN = IS_PROD ? 'refreshToken' : 'refreshToken_';

/** 1 year (unit: day) */
export const COOKIE_LOG_TRACKING_CLIENT_ID_AGE = 365;
export const COOKIE_LOG_TRACKING_CLIENT_ID = IS_PROD ? '_t_cid' : '_t_cid_';

/** 30 minutes (unit: day) */
export const COOKIE_LOG_TRACKING_SESSION_ID_AGE = 1 / 48;
export const COOKIE_LOG_TRACKING_SESSION_ID = IS_PROD ? '_t_sid' : '_t_sid_';

export const COOKIE_KEY_DELIVER_SESSION_ID = 'connect.sid';
export const COOKIE_VIEW_ID = 'view.id';
export const COOKIE_CROSS_SITE_ASSERT = 'COOKIE_CROSS_SITE_ASSERT';

export const COOKIE_DRAMA_ID = 'drama_id';

const browser = browserName(isBrowser && navigator.userAgent);
/**
 * 避免 MacOS < 10.15, iOS < 13, 把 `SameSite=None` 當成 `SameSite=Strict` 的 bug
 * @see {@link https://www.chromium.org/updates/same-site/incompatible-clients}
 **/
export const IS_SUPPORT_SAME_SITE_NONE_COOKIE =
  Boolean(browser) && ['ios', 'safari'].every((vendor) => vendor !== browser);
